import EventModule from 'containers/purchase/modules/event_module/event_module'
import ExperticketIframeModule from 'containers/purchase/modules/experticket_iframe_module/experticket_iframe_module'
import eventState from 'containers/purchase/modules/event_module/event_state'
import experticketIframeState from 'containers/purchase/modules/experticket_iframe_module/experticket_iframe_state'
import {get} from 'lodash'

const IFRAME_CONTAINER_ID = 'flowui-container'

const config = (params) => {
  const reservationMapper = (ctx) => {
    return {
      event_id: ctx.event.id,
      ticket_types: ctx.tickets,
      params: {
        token: ctx.token,
        items: ctx.items
      }
    }
  }

  let steps = {}

  steps['eventStep'] = {
    component: EventModule,
    autoNext: true,
    states: eventState,
    context: {
      year_month: params.initialYearMonth,
      event_groups: [],
      event: null
    }
  }

  steps['iframeStep'] = {
    component: ExperticketIframeModule,
    autoNext: false,
    states: experticketIframeState,
    context: {
      iframe_container_id: IFRAME_CONTAINER_ID,
      iframeLink: null,
      iframe_height: 'auto',
      iframe_key: 0,
      tickets: []
    }
  }

  return {
    reservationMapper: reservationMapper,
    steps: steps
  }
}

export default config
